import { HTMLPreview } from './HTMLPreview';
import { ImagePreview } from './ImagePreview';
import { VideoPreview } from './VideoPreview';

export * from './UnknownPreview';

export const previewComponents = [HTMLPreview, ImagePreview, VideoPreview];
